<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>{{ $t('communityManage.queryTitle') }}</span>
          </div>
          <el-form :inline="true" :model="communityManageInfo.conditions" class="demo-form-inline">
            <el-form-item>
              <el-input v-model="communityManageInfo.conditions.communityId" 
                        :placeholder="$t('communityManage.communityIdPlaceholder')"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="communityManageInfo.conditions.name" 
                        :placeholder="$t('communityManage.namePlaceholder')"></el-input>
            </el-form-item>
            <el-form-item>
              <area-select 
                ref="areaSelect"
                @notifyArea="handleAreaChange"></area-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="_queryCommunityMethod">
                <i class="el-icon-search"></i> {{ $t('common.query') }}
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>{{ $t('communityManage.communityInfoTitle') }}</span>
            <el-button type="primary" size="small" @click="_openAddCommunityModal" style="float: right;">
              <i class="el-icon-plus"></i> {{ $t('communityManage.addCommunity') }}
            </el-button>
          </div>
          <el-table
            :data="communityManageInfo.communitys"
            border
            style="width: 100%">
            <el-table-column prop="communityId" :label="$t('communityManage.communityId')"></el-table-column>
            <el-table-column prop="name" :label="$t('communityManage.name')"></el-table-column>
            <el-table-column prop="nearbyLandmarks" :label="$t('communityManage.nearbyLandmarks')" width="25%"></el-table-column>
            <el-table-column prop="cityName" :label="$t('communityManage.cityCode')"></el-table-column>
            <el-table-column 
              v-for="(item,index) in communityManageInfo.listColumns" 
              :key="index"
              :label="item.specName">
              <template slot-scope="scope">
                {{ scope.row.listValues[index] }}
              </template>
            </el-table-column>
            <el-table-column prop="stateName" :label="$t('communityManage.state')"></el-table-column>
            <el-table-column :label="$t('common.operation')" align="right">
              <template slot-scope="scope">
                <el-button-group>
                  <el-button 
                    v-if="scope.row.state == '1200' && communityManageInfo.storeTypeCd == '800900000001'"
                    size="mini" 
                    @click="_openDeleteCommunityModel(scope.row)">
                    {{ $t('common.delete') }}
                  </el-button>
                  <el-button 
                    size="mini"
                    :disabled="scope.row.state == '1100' && communityManageInfo.storeTypeCd != '800900000001'"
                    @click="_openEditCommunityModel(scope.row)">
                    {{ $t('common.edit') }}
                  </el-button>
                  <el-button 
                    v-if="scope.row.state != '1000' && communityManageInfo.storeTypeCd == '800900000001'"
                    size="mini"
                    @click="_openRecallCommunityModel(scope.row)">
                    {{ $t('communityManage.recallAudit') }}
                  </el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :total="communityManageInfo.total">
          </el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <add-community ref="addCommunity"></add-community>
    <edit-community ref="editCommunity"></edit-community>
    <delete-community ref="deleteCommunity"></delete-community>
    <recall-audit-finish-community ref="recallAuditFinishCommunity"></recall-audit-finish-community>
  </div>
</template>

<script>
import { getCommunityList } from '@/api/common/communityManage/communityManageApi'
import AreaSelect from '@/components/common/areaSelect/areaSelect'
import AddCommunity from '@/components/common/addCommunity/addCommunity'
import EditCommunity from '@/components/common/editCommunity/editCommunity'
import DeleteCommunity from '@/components/common/deleteCommunity/deleteCommunity'
import RecallAuditFinishCommunity from '@/components/common/recallAuditFinishCommunity/recallAuditFinishCommunity'

export default {
  components: {
    AreaSelect,
    AddCommunity,
    EditCommunity,
    DeleteCommunity,
    RecallAuditFinishCommunity
  },
  data() {
    return {
      communityManageInfo: {
        communitys: [],
        total: 0,
        storeTypeCd: '',
        conditions: {
          name: '',
          cityCode: '',
          communityId: ''
        },
        listColumns: []
      },
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this._initMethod()
  },
  methods: {
    _initMethod() {
      this._getColumns(() => {
        this._listCommunitys(this.currentPage, this.pageSize)
      })
    },
    _listCommunitys(page, rows) {
      const params = {
        ...this.communityManageInfo.conditions,
        page,
        row: rows
      }
      
      getCommunityList(params).then(res => {
        this.communityManageInfo.total = res.total
        this.communityManageInfo.communitys = res.communitys
        this.dealCommunityAttr(res.communitys)
      }).catch(error => {
        console.error('请求失败:', error)
      })
    },
    _openAddCommunityModal() {
      this.$refs.addCommunity.open()
    },
    _openEditCommunityModel(community) {
      this.$refs.editCommunity.open(community)
    },
    _openDeleteCommunityModel(community) {
      this.$refs.deleteCommunity.open(community)
    },
    _openRecallCommunityModel(community) {
      this.$refs.recallAuditFinishCommunity.open(community)
    },
    _queryCommunityMethod() {
      this.currentPage = 1
      this._listCommunitys(this.currentPage, this.pageSize)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listCommunitys(this.currentPage, this.pageSize)
    },
    handleAreaChange(data) {
      this.communityManageInfo.conditions.cityCode = data.selectArea
    },
    dealCommunityAttr(communitys) {
      communitys.forEach(item => {
        this._getColumnsValue(item)
      })
    },
    _getColumnsValue(community) {
      community.listValues = []
      if (!Object.prototype.hasOwnProperty.call(community,'communityAttrDtos') || community.communityAttrDtos.length < 1) {
        this.communityManageInfo.listColumns.forEach(() => {
          community.listValues.push('')
        })
        return
      }

      const communityAttrDtos = community.communityAttrDtos

      this.communityManageInfo.listColumns.forEach(value => {
        let tmpValue = ''
        communityAttrDtos.forEach(attrItem => {
          if (value.specCd == attrItem.specCd) {
            tmpValue = attrItem.value
          }
        })
        community.listValues.push(tmpValue)
      })
    },
    _getColumns(callback) {
      this.communityManageInfo.listColumns = []
      // 这里应该调用获取列配置的API
      // 模拟获取列配置
      callback()
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
</style>